import { fg } from '@atlaskit/platform-feature-flags';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

/**
 * Checks if ADF streaming is enabled based on different experiments
 * for different prompts.
 *
 * @param fireExposureEvent - if true, will fire exposure event for the experiment. Default is false.
 *
 * @returns true if adf streaming is enabled
 * @example
 * ```ts
 * if (isAdfStreamingEnabled()) {
 *   // do something
 * }
 * ```
 */
export function isAdfStreamingEnabled(fireExposureEvent: boolean = false) {
	if (fireExposureEvent) {
		const isIWEnabled =
			expValEquals('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gpt41mini') ||
			expValEquals('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gemini25flash');
		const isNonIWEnabled =
			expValEquals('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gpt41mini') ||
			expValEquals('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gemini25flash');
		return isIWEnabled || isNonIWEnabled;
	}

	return (
		fg('platform_editor_ai_adf_prompts_in_all_products') ||
		expValEqualsNoExposure('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gpt41mini') ||
		expValEqualsNoExposure('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gemini25flash') ||
		expValEqualsNoExposure('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gpt41mini') ||
		expValEqualsNoExposure('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gemini25flash')
	);
}
